exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oWyrY{margin-left:16px;margin-left:1rem;margin-right:16px;margin-right:1rem;max-width:1180px}@media screen and (min-width:768px){.oWyrY{margin-left:auto;margin-right:auto}}@media screen and (min-width:768px){._2ZeU2{margin:0 auto 3rem;width:66.66667%}}", ""]);

// exports
exports.locals = {
	"wrapper": "oWyrY",
	"container": "_2ZeU2"
};